<template>
	<div class="about">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="banner">
			<img src="../assets/images/about/banner@2x.png" />
		</div>
		<div class="title" style="margin-top:50px;">体验我们非一般的时尚服装</div>
		<div class="content">宏凯集团成立于1990年，起源于湖滨时装厂。公司创立之初，随着改革开放的步伐，不断拓展国内外市场。公司于2005年在澳大利亚墨尔本设立分公司，2010年在美国洛杉矶分公司，2013年在新西兰奥克兰分公司，2018年在柬埔寨成立了鹏泰制衣有限公司。随着集团的逐步发展，为进一步加强国内与海外市场的连接，于2014年在国内成立了泉州鹏泰服饰有限公司，并建立了智能制造服装生产工厂。在此基础上，公司于2023年成立了福建省盼达智能科技有限公司，推出了BOCINI服装定制平台，实现从研发、设计、纺织、印花、绣花到成衣生产及定制销售的一体化全产链服务。并通过BOCINI定制平台，我们致力于开拓国内服装定制市场。BOCINI 系宏凯集团旗下的高端服装定制平台。</div>

		<div class="message-box">
			<div class="left">
				<div class="title">欢迎给我们留言</div>
				<div class="input-box">
					<label class="name">
						<div class="input-title">*姓名</div>
						<input />
					</label>
					<label class="mail">
						<div class="input-title">*邮箱</div>
						<input />
					</label>
				</div>
				<div>
					<div class="input-title">留言信息</div>
					<textarea />
				</div>
				<button class="submit-message">提交留言</button>
			</div>
			<div class="contant-us">
				<div class="item">
					<div class="about-box">
						<img src="../assets/images/about/phone.png" />
						<span>联系电话</span>
					</div>
					<div class="about-content"> {{ '189 6586 8706' }} </div>
			</div>
			<div class="item">
				<div class="about-box">
					<img style="width:26px;height:26px;" src="../assets/images/about/fax.png" />
					<span>电话传真</span>
				</div>
				<div class="about-content">
					<div>0595-68096809</div>
					<div>0595-68583123</div>
				</div>
			</div>
			<div class="item">
					<div class="about-box">
						<img style="width:26px;height:19px;" src="../assets/images/about/mail.png" />
						<span>公司邮箱</span>
					</div>
					<div class="about-content"> xingzheng05_hk@163.com </div>
				</div>
				<div class="item">
					<div class="about-box">
						<img style="width:22px;height:26px;" src="../assets/images/about/address.png" />
						<span>公司地址</span>
					</div>
					<div class="about-content"> 福建省石狮市锦尚镇纺织服装发展基地泉州鹏泰服饰有限公司 </div>
				</div>
				<div id="map"></div>

			</div>
		</div>
	</div>

</template>

<script>
	import Breadcrumb from "@/components/Breadcrumb.vue";


	export default {
		name: "About",
		components: {
			Breadcrumb
		},
		data() {
			return {
				crumb: [{
					title: "联系我们",
					path: "about",
				}, ],

			};
		},
		mounted() {
			this.initMap()
		},
		methods: {
			initMap() {
				// 定义地图中心点坐标
				var center = new window.TMap.LatLng(24.721793, 118.708727)
				// 定义map变量，调用 TMap.Map() 构造函数创建地图
				var map = new window.TMap.Map(document.getElementById('map'), {
					center: center, // 设置地图中心点坐标
					zoom: 10 // 设置地图缩放级别

				})
				console.log(map)
				console.log(window)
			}
		},
	};
</script>

<style scoped lang="scss">
	.about {
		width: 1170px;
		margin: 20px auto;

		.banner {
			margin-top: 20px;
			width: 100%;
			height: 200px;
		}

		.title {
			height: 40px;
			font-size: 28px;
			font-family: PingFang SC;
			font-weight: 400;
			line-height: 40px;
			color: #666666;
			width: 100%;
			text-align: center;

		}

		.content {
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			line-height: 30px;
			color: #666666;
			margin-top: 20px;
			text-indent: 50px;
		}

		.message-box {
			margin-top: 60px;
			margin-bottom: 70px;
			display: flex;

			.title {
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: bold;
				line-height: 25px;
				color: #404040;
				text-align: left;
			}

			.input-title {
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				line-height: 22px;
				color: #000000;
			}

			.name {
				width: 271px;
			}

			.mail {
				width: 370px;
				margin-left: 30px;
			}

			input {
				height: 42px;
				background: #FFFFFF;
				border: 1px solid #9B9B9B;
				margin-top: 10px;
				width: 100%;
			}

			textarea {
				width: 672px;
				height: 166px;
				background: #FFFFFF;
				border: 1px solid #9B9B9B;
				margin-top: 10px;
			}

			.submit-message {
				width: 130px;
				height: 44px;
				background: #0F114A;
				opacity: 1;
				border-radius: 2px;
				text-align: center;
				font-size: 17px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #EDD4AC;
				margin-top: 20px;
				cursor: pointer;

			}
		}

		.input-box {
			display: flex;
			align-items: center;
			margin-bottom: 30px;
		}

		.contant-us {
			margin-left: 30px;

			.item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 37px;

				.about-box {
					display: flex;
					align-items: center;

					img {
						width: 26px;
						height: 24px;
					}

					span {
						font-size: 15px;
						font-family: PingFang SC;
						font-weight: bold;
						line-height: 18px;
						color: #0F114A;
						margin-left: 20px;
					}

				}

				.about-content {
					width: 70%;
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: bold;
					line-height: 18px;
					color: #666666;
					text-align: right;
				}
			}

			#map {
				width: 465px;
				height: 166px;
				border: 2px solid #EDD4AC;
				opacity: 1;
			}
		}

	}
</style>
